import { Props } from "./types";

const Description = ({ className }: Props) => {
  return (
    <div className={`${className} xl:w-96`}>
      <h2 className="text-[2.375rem]/[42px] font-bold mt-2 sm:mt-24 md:mt-36 xl:mt-24 xl:text-5xl text-center md:text-left ">
        Rent your future home and{" "}
        <span className="text-landing-cherry">get 100% of your rent back</span> to use as a deposit
      </h2>
      <div className="text-base mt-7">
        With Keyzy, enjoy <b>fixed rent for 2 years</b> and the{" "}
        <b>option to buy your home at a guaranteed price</b>, giving you the freedom to buy when
        you’re ready – all while building your deposit from day one.
      </div>
    </div>
  );
};

export default Description;
